<fragment v-if="shouldRenderConfig">
    <!-- show existing custom formats  -->
    <appPageOptionAttributes
        v-for="(pageOptionAttributes,index) in getCustomFormats"
        v-bind:key="index"
        v-bind:propsData="pageOptionAttributes"
    ></appPageOptionAttributes>
    <appInputCustomFormatInsert v-if="nrItems > 1"></appInputCustomFormatInsert>
</fragment>

